import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BehaviorsPageRoutingModule } from './behaviors-routing.module';

import { BehaviorsPage } from './behaviors.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BehaviorsPageRoutingModule
  ],
  declarations: [BehaviorsPage]
})
export class BehaviorsPageModule {}
